import { faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect } from 'react';

interface SlideInDivProps {
  isVisible: boolean;
  onClose: () => void;
  text: string; // Add text prop
  imageUrl: string; // Add image URL prop
}

const SlideInDiv: React.FC<SlideInDivProps> = ({ isVisible, onClose, text, imageUrl }) => {
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        onClose();
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [isVisible, onClose]);

  return (
    <div
      className={`group
        w-full md:w-[500px] fixed bottom-14 p-3 z-10
        md:left-[37.5%] left-1/2 transform -translate-x-1/2 max-w-sm md:max-w-lg transition-transform duration-500 ${
        isVisible ? 'translate-y-0 opacity-100 pointer-events-auto' : 'translate-y-full opacity-0 pointer-events-none'
      }`}
    >
      <div
        className="flex flex-row h-full justify-between bg-cover bg-center p-4 rounded-2xl relative"
        style={{ backgroundImage: `url(${imageUrl})` }} // Use the imageUrl prop
      >
        <div className="flex flex-col">
          <div className="text-2xl font-semibold py-3">Та бол {text}</div> {/* Use the text prop */}
        </div>
        <div className="flex items-center justify-center h-full">
          <FontAwesomeIcon icon={faChevronUp} size="2x" className="text-4xl" />
        </div>
      </div>
    </div>
  );
};

export default SlideInDiv;
